<script lang="ts">
  import { computed, defineComponent, inject, ref } from 'vue'
  import { getComponentNamespace, getNamespace } from '../../../utils/global-config'
  import { useIndex } from '../../../hooks/use-index'
  import { timelineItemProps } from './props'
  import type { TimelineContext } from './context'
  import { timelineInjectionKey } from './context'

  export default defineComponent({
    name: getComponentNamespace('TimelineItem'),
    components: {},
    props: timelineItemProps,
    emits: ['close'],
    setup(props, { slots }) {
      // 定义组件命名
      const ns = getNamespace('timeline-item')
      // 获取父级组件provide数据
      const context = inject(timelineInjectionKey)
      // Ref
      const itemRef = ref<HTMLElement>()
      // 点颜色
      const innerDotColor = ref(props.dotColor)
      // 内部Index
      const { innerIndex } = useIndex({
        itemRef,
        selector: `.${ns}`,
        parentClassName: context?.parentCls
      })
      // 是否为最后一个
      const isLast = computed((): boolean => {
        const { reverse, count } = context as TimelineContext
        return !reverse ? innerIndex.value + 1 === count : innerIndex.value == 0
      })
      // 组件class
      const cls = computed(() => [ns, isLast.value && 'is-last'])
      // lineType
      const lineType = computed(() => [
        {
          borderLeftStyle: context?.lineType
        }
      ])
      // slotsIcon
      const iconCls = computed(() =>
        slots?.icon?.() ? [`${ns}__dot__icon`, 'is-slot-icon'] : [`${ns}__dot__icon`]
      )
      /**
       * @description 待返回数据
       */
      return {
        ns,
        cls,
        itemRef,
        innerDotColor,
        isLast,
        lineType,
        iconCls
      }
    }
  })
</script>

<template>
  <div ref="itemRef" :class="cls">
    <div :class="`${ns}__dot`">
      <div v-if="!isLast" :class="`${ns}__dot__line`" :style="lineType"></div>
      <div :class="iconCls">
        <slot name="icon">
          <i class="icon" :style="[{ backgroundColor: innerDotColor }]"></i>
        </slot>
      </div>
    </div>
    <div :class="`${ns}__content`">
      <slot>
        <div :class="`${ns}__content__label`">
          <slot name="label"></slot>
        </div>
        <div :class="`${ns}__content__description`">
          <slot name="description"></slot>
        </div>
      </slot>
    </div>
  </div>
</template>
